import React, { useState,useEffect } from "react";
import Login from "../pages/auth/Login";
import ForgetPasswordModal from "./ForgetPasswordModal";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    LOGIN_USER_FAILED
} from '../constants/actionTypes';
const LoginModal = ({ onClose, onLoginSuccess, openRegisterModal }) => {
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(true); // default open
    const dispatch = useDispatch();
    const { t} = useTranslation();
    const failure = (error) => {
    return { type: LOGIN_USER_FAILED, payload: error };
  };
  useEffect(() => {
    if (!isLoginModalOpen) {
      dispatch(failure("")); 
    }
  }, [isLoginModalOpen]);
  return (
    <div>
      {isLoginModalOpen && (
        <>
          <Login
            onLoginSuccess={onLoginSuccess}
            setIsLoginModalOpen={setIsLoginModalOpen}   
          />
          
          <span
            style={{ cursor: "pointer", color: "#B3261E" }}
            onClick={() => {
              setIsLoginModalOpen(false);
              setIsForgotModalOpen(true);
            }}
          >
           {t(`loginPop.forgotPassword`)}?
          </span>

          <p className="login-modal">
              {t(`loginPop.noAccount`)}
              {" "}
            <span
              onClick={openRegisterModal}
              style={{ cursor: "pointer", color: "#00bcf7" }}
            >
               {t (`loginPop.registerHere`)}
            </span>
          </p>
        </>
      )}

      {isForgotModalOpen && (
        <ForgetPasswordModal
          setIsForgotModalOpen={setIsForgotModalOpen}
        
          openLoginModal={() => {
            setIsForgotModalOpen(false);
            setIsLoginModalOpen(true);
          }}
        />
      )}
    </div>
  );
};

export default LoginModal;
